import { render, staticRenderFns } from "./TroubleshootingPro.vue?vue&type=template&id=3211a7b5"
import script from "./TroubleshootingPro.vue?vue&type=script&lang=js"
export * from "./TroubleshootingPro.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports